import React from "react";
import contextProvider from "app/contextProvider";
import { Row, Col } from "reactstrap";
// import { Link } from "react-router-dom";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
// import ReactOButton from "app/_L1_components/Elements/ReactOButton";

class ServicePage extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {};
    super(props, initState);
  }

  onComponentDidMount() {
    if (!this.getAppContext().authHandler.getAccountData().message) {
      this.getAppContext().redirectTo("/dashboard");
    }
  }

  onRender() {
    const message = this.getAppContext().authHandler.getAccountData().message;
    return (
      <Section
        designType="narrow"
        className={this.getAppContext().media.isMobile ? "mt-1" : "mt-3"}
      >
        <Panel
          rounded
          className="mb-4"
          style={{
            minHeight: "50px",
          }}
        >
          <Row>
            <Col>
              <div className="py-2">
                <h3 className="pb-3">
                  {this.getAppContext().conf.STATIC_PAGE[message].title}
                </h3>
                {this.getAppContext().conf.STATIC_PAGE[message].text}
              </div>
            </Col>
          </Row>
        </Panel>
      </Section>
    );
  }
}

export default contextProvider(ServicePage, {
  define: null,
});
